import React from 'react'

export default function POItemInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .po-wrapper {
          padding: 20px;
          box-sizing: border-box;
        }
        #po-item-container {
          border: solid 0.75px lightgrey;
          margin: auto;
          user-select: text;
        }
        .item-details-table {
          width: 100%;
          font-size: 0.65em;
        }
        .item-details-table thead {
          background-color: lightgrey;
        }
        .item-details-table th, td {
          text-align: left;
          padding: 8px;
        }
        #po-header-container {
          margin: 2px;
          padding: 10px;
          background-color: lightgrey;
          font-size: 1.5rem;
          font-weight: bold;
        }
        #po-header-details-container {
          display: flex;
          padding: 10px;
        }
        .fields-group-container {
          flex: 1;
        }
        #group-1-fields-container {

        }
        #spacer{
          width: 5%;
        }
        .field-group {
          margin: 5px;
          font-size: 0.65em;
          display: flex;
        }
        .field-group label {
          font-weight: bold;
          flex: 3;
        }
        .field-group p {
          flex: 5;
        }
      `}
      </style>
    </React.Fragment>
  )
}
